import React, { Component } from 'react';
import { connect } from 'react-redux';

// import { FindPassword } from 'web/components/common/modal';
import { VertifyPhone } from 'web/components/common/modal';
import Dim from 'web/components/common/modal/common/Dim';
import { initModal, pushModal } from 'shared/actions/modal.action';

import {
  startVertifyPhoneData,
  finishVertifyPhoneData,
  setVertifyPhoneData,
  getSendPhoneAuthRequest,
  getVerifyCodeRequest,
  getVerifyCodeInFindEmailRequest,
} from 'shared/actions/auth.action';

import {
  startFindData,
  finishFindData,
  setFindData,
  getFindEmailRequest,
  getFindPasswordRequest,
} from 'shared/actions/auth.action';

@connect(
  (state, props) => ({
    auth: state.shared.auth,
    modal: state.shared.modal,
  }),
  {
    initModal,
    pushModal,

    startFindData,
    finishFindData,
    setFindData,
    getFindEmailRequest,
    getFindPasswordRequest,

    // Vertify phone
    startVertifyPhoneData,
    finishVertifyPhoneData,
    setVertifyPhoneData,
    getSendPhoneAuthRequest,
    getVerifyCodeRequest,
    getVerifyCodeInFindEmailRequest,
  },
)
class FindEmailContainer extends Component {
  phoneRegExp = /^\d{3}\d{3,4}\d{4}$/;

  componentDidMount() {
    this.props.startVertifyPhoneData();
  }

  componentWillUnmount() {
    this.props.finishVertifyPhoneData();
  }

  handleChange = async e => {
    const key = e.target.name;
    const value = e.target.value;
    // console.log({ key, value });

    await this.props.setVertifyPhoneData({ [key]: value });
    if (key === 'phoneCode' && value.trim().length === 6) {
      // console.log({ key, value });
      // this.comparePhoneCode();
    }
    return;
  };

  handlePhoneCodeRequest = async () => {
    const { vertifyPhone = {} } = this.props.auth;
    const { phone } = vertifyPhone;
    // console.log({ phone });
    if (!phone.trim() || phone.trim().length < 10)
      return alert('phone 번호를 입력해 주세요');
    await this.props.getSendPhoneAuthRequest({ phone, type: 'vertifyPhone' });
  };

  handleBlur = e => {
    const key = e.target.name;
    const value = e.target.value;
    // console.log({ key, value });
    if (key === 'phoneCode' || value.trim().length >= 6) {
      const { vertifyPhone = {} } = this.props.auth;
      const { verification = {} } = vertifyPhone;
      const vertifyList = ['phone', 'phoneCode'];
      const falseList = vertifyList.filter(item =>
        verification[item] ? false : true,
      );
      if (falseList.length) {
        // this.comparePhoneCode();
      }
    }
  };

  comparePhoneCode = callback => {
    const { vertifyPhone } = this.props.auth;
    const { phoneCode, phone } = vertifyPhone;
    // Todo: Compare Request
    // console.log(`comparePhoneCode`, { phoneCode, phone });
    if (phoneCode.length >= 6)
      this.props.getVerifyCodeInFindEmailRequest({
        phoneCode,
        phone,
        type: 'vertifyPhone',
      });
  };

  handleInit = () => {
    // console.log(`handleInit`);
    this.props.startVertifyPhoneData();
    document.getElementById('input-phone').focus();
  };

  handleSubmit = (e, popup) => {
    // console.log(`handleSubmit`);
    if (e) e.preventDefault();

    if (popup) return this.props.pushModal(popup);

    this.comparePhoneCode();
  };

  render() {
    const { vertifyPhone = {} } = this.props.auth;
    const { phone, phoneCode, verification = {}, error = {} } = vertifyPhone;

    const vertifyList = ['phone', 'phoneCode'];
    const falseList = vertifyList.filter(item =>
      verification[item] ? false : true,
    );

    // const { find = {} } = this.props.auth;
    // const { phone, message } = find;

    return (
      <Dim>
        <VertifyPhone
          modal={this.props.modal}
          text={{
            title: '비밀번호 찾기',
            submit: '비밀번호 찾기',
            join: '새로 가입하기',
          }}
          active={true}
          type="vertify"
          phone={phone}
          phoneCode={phoneCode}
          verification={verification}
          falseList={falseList}
          error={error}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          handleBlur={this.handleBlur}
          handlePopup={this.props.popupHandler}
          handleBack={this.props.popupHandler.login}
          handleInit={this.handleInit}
          sendVerificationNumber={this.handlePhoneCodeRequest}
          // overlapCheck={false}
        />
        {/* 
      <FindPassword
        phone={phone}
        error={message}
        handleChange={this.handleChange}
        handleSubmit={this.findEmail}
        handlePopup={this.props.popupHandler}
      /> */}
      </Dim>
    );
  }
}

export default FindEmailContainer;
